// @flow
export const SUBSEQUENT_FLEX_DATES_OPTIONS_TOGGLE =
    'SUBSEQUENT_FLEX_DATES_OPTIONS_TOGGLE';
export type SubsequentFlexDatesOptionsToogleActionType =
    'SUBSEQUENT_FLEX_DATES_OPTIONS_TOGGLE';

export type SubsequentFlexDatesOptionsToogleAction = {
    type: SubsequentFlexDatesOptionsToogleActionType,
    payload: {isSubsequentFlexDatesView: boolean}
};

const ACTION_CREATORS = {
    toggleSubsequentFlexDatesView(
        isSubsequentFlexDatesView: boolean
    ): SubsequentFlexDatesOptionsToogleAction {
        return {
            type: SUBSEQUENT_FLEX_DATES_OPTIONS_TOGGLE,
            payload: {isSubsequentFlexDatesView}
        };
    }
};

export default {
    ...ACTION_CREATORS
};
